import React from 'react';
import GlobalNoteStandard from './GlobalNoteStandard';
import GlobalNoteTraceability from './GlobalNoteTraceability';
import LinkedNoteResolver from './LinkedNoteResolver';
import { LINKED_NOTE_TITLE, MC_NOTE_HISTORY } from './constants';

interface Props {
    note: any;
}

const GlobalNoteResolver: React.FC<Props> = ({ note }) => {
    const linkedTitle: string | undefined = note?.data?.customFields?.forms?._note_?.title;
    if (linkedTitle && linkedTitle.includes(LINKED_NOTE_TITLE)) {
        return <LinkedNoteResolver note={note} />;
    }
    return note && note['@type'] === MC_NOTE_HISTORY ? (
        <GlobalNoteStandard note={note} />
    ) : (
        <GlobalNoteTraceability note={note} />
    );
};

export default GlobalNoteResolver;
